import { FeatureDefinition } from '../entities';

export const applePayExperiment = 'ab_gs_all_payment_with_no_form_ar_0826';

export enum ApplePayExperimentGroups {
  CONTROL = 'control',
  TEST_B = 'test_b',
  TEST_C = 'test_c',
}

export const applePayExperimentConfig: FeatureDefinition = {
  defaultValue: ApplePayExperimentGroups.CONTROL,
};
